export default __webpack_public_path__ + "static/media/April2020.fea0524d.png";